import { Box, Button } from "@mui/material";
import { useFormikContext } from "formik";
import { useState } from "react";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import AddAppointment from "../../accident/accidentDashboard/appointmentsCalendar/addAppointment";
import AppointmentSession from "../../accident/accidentDashboard/appointmentsCalendar/session/appointmentSession";
import FpaAppointmentCard from "./fpaAppointmentCard";

const formatAppointment = (appointment) => {
  return (appointment = {
    ...appointment,
    fromDB: false,
  });
};

const FpaAppointment = ({ idArt, idSiniestro, trabajador, disabled, artFields, preloadedProfessional, preloadedMnMd, preloadedSpecialty }) => {
  const { setFieldValue, values } = useFormikContext();
  const [openAppointmentSession, setOpenAppointmentSession] = useState(false);
  const [openAddAppointment, setOpenAddAppointment] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [appointmentsCollection, setAppointmentsCollection] = useState(false);
  const [appointment, setAppointment] = useState();

  const appointmentArtFields = {
    fechaHora: artFields?.fechaHoraPedido,
    profesionalApellidoNombre: artFields?.profesionalApellidoNombre,
    matricula: artFields?.profesionalMnMp,
    especialidad:
      artFields?.especialidadInforme || artFields?.especialidadProfesional,
    observacion: artFields?.detalleAutorizacion,
  };

  const handleSubmitSessions = (appointments) => {
    setFieldValue(
      "turnos",
      appointments.map((a) => formatAppointment(a)),
    );
    setOpenAppointmentSession(false);
  };

  const handleSubmitAppointment = (appointment) => {
    if (appointmentsCollection) {
      setAppointment(appointment);
      setOpenAppointmentSession(true);
      setOpenAddAppointment(false);
      setAppointmentsCollection(false);
    } else {
      setFieldValue("turnos", [formatAppointment(appointment)]);
      setOpenAddAppointment(false);
    }
  };
  const handleDeleteAppointment = (idAppointment) => {
    let auxAppointment = values.turnos[idAppointment];
    auxAppointment.DesvincularNroTransaccionFpa = true;
    let appointments = [...values.turnos];
    appointments.splice(idAppointment, 1);
    setFieldValue("turnos", appointments);
    if (auxAppointment.fromDB) {
      let auxAppointments = [...values.turnosADesvincular];
      auxAppointments.push(auxAppointment);
      // Agrego a la lista de turnos a desasociar de fpa cuando se guarde
      setFieldValue(`turnosADesvincular`, auxAppointments);
    }
  };

  const handleCloseAll = () => {
    setOpenAddAppointment(false);
    setOpenAppointmentSession(false);
    setConfirmDialogOpen(false);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: 1,
      }}>
      <AddAppointment
        open={openAddAppointment}
        handleClose={() => setOpenAddAppointment(false)}
        handleOpenConfirmDialog={() => setConfirmDialogOpen(true)}
        artFields={appointmentArtFields}
        handleSubmit={handleSubmitAppointment}
        artId={idArt}
        openInCalendar
        openAppointmentCollection={() => setAppointmentsCollection(true)}
        preloadedProfessional={preloadedProfessional}
        preloadedMnMd={preloadedMnMd}
        preloadedSpecialty={preloadedSpecialty}
      />

      <AppointmentSession
        appointment={appointment}
        open={openAppointmentSession}
        handleClose={() => setOpenAppointmentSession(false)}
        handleOpenConfirmDialog={() => setConfirmDialogOpen(true)}
        artId={idArt}
        siniestro={idSiniestro}
        trabajador={trabajador}
        handleSubmit={handleSubmitSessions}
      />
      <ConfirmDialog
        open={confirmDialogOpen}
        handleClose={() => setOpenAppointmentSession(false)}
        handleConfirm={handleCloseAll}
        title="CERRAR VENTANA"
        text="¿Está seguro que desea cancelar esta operación? En caso de aceptar, se perderá la información ingresada"
      />
      <FpaAppointmentCard
        turnos={values.turnos}
        disabled={disabled}
        handleDelete={handleDeleteAppointment}
      />
      {values.turnos.length == 0 && (
        <Button
          color="primary"
          variant="outlined"
          onClick={() => setOpenAddAppointment(true)}
          disabled={disabled}>
          Agregar turno
        </Button>
      )}
    </Box>
  );
};

export default FpaAppointment;
